import React from 'react';
import '../css/CareerOpportunities.css';

const CareerOpportunities = () => {
  const jobRoles = [
    { id: 1, icon: "🛡️", title: "Safety Officer" },
    { id: 2, icon: "🧯", title: "Fire Supervisor" },
    { id: 3, icon: "⛑️", title: "HSE Officer" },
    { id: 4, icon: "⚙️", title: "Safety Engineer" }
  ];

  return (
    <section className="gfi-career-section">
      <div className="gfi-career-container">
        
        {/* SECTION CENTERED HEADER */}
        <div className="gfi-career-header">
          <span className="gfi-career-badge">CAREER OPPORTUNITIES</span>
          <h2 className="gfi-career-title">
            After completing Fire & Safety or NEBOSH courses, you can work as:
          </h2>
        </div>

        {/* 4-COLUMN ROLES CARD GRID MESH */}
        <div className="gfi-career-roles-grid">
          {jobRoles.map((role) => (
            <div key={role.id} className="gfi-role-card">
              <div className="gfi-role-icon-wrapper">
                <span className="gfi-role-emoji">{role.icon}</span>
              </div>
              <h3 className="gfi-role-card-title">{role.title}</h3>
            </div>
          ))}
        </div>

        {/* BOTTOM METRICS STATS BAR STRIP */}
        <div className="gfi-career-metrics-strip">
          
          <div className="gfi-metric-item-block">
            <h4 className="gfi-metric-label-title">Top Industries</h4>
            <p className="gfi-metric-desc-text">Construction | Oil & Gas | Manufacturing | Power Plants</p>
          </div>
          
          <div className="gfi-metric-item-block divider-left">
            <h4 className="gfi-metric-label-title">Fresher Salary Range</h4>
            <p className="gfi-metric-desc-text">₹16,000 – ₹25,000+ per month</p>
          </div>
          
          <div className="gfi-metric-item-block divider-left">
            <h4 className="gfi-metric-label-title">Global Reach</h4>
            <p className="gfi-metric-desc-text">International job opportunities available</p>
          </div>

        </div>

      </div>
    </section>
  );
};

export default CareerOpportunities;